import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { Typography } from '@material-ui/core';
import { DSTheme } from '../../styles/themes/types';
import { DSButton } from '../Button/Button';

interface CustomWideCardProps {
  customStyles?: string;
}

interface WideCardProps extends CustomWideCardProps {
  title: string;
  description?: string;
  imgSrc: string;
  imgAlt: string;
  buttonText: string;
  onClick: () => void;
  special?: boolean;
}

const useStyles = makeStyles((theme: DSTheme) => ({
  wideCard: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '568px',
    height: '340px',
    padding: '30px',

    background: theme.palette.background.elevation1,
    boxShadow: '0px 5px 26px rgba(0, 0, 0, 0.06)',
    borderRadius: '16px',
  },
  wideCardContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '250px',
    height: '220px',
    marginLeft: '3rem',
  },
  specialCard: {
    background: theme.palette.background.specialCard,
  },
  specialTitle: {
    color: theme.palette.primary.contrastText,
  },
}));

export const WideCard: React.FC<WideCardProps> = ({
  title,
  description,
  imgSrc,
  imgAlt,
  buttonText,
  onClick,
  special,
}) => {
  const classes = useStyles();
  return (
    <div className={`${classes.wideCard} ${special ? classes.specialCard : ''}`}>
      <div className={classes.wideCardContent}>
        <Typography className={`${special ? classes.specialTitle : ''}`} variant="h1">
          {title}
        </Typography>

        {description && (
          <Typography>
            <div dangerouslySetInnerHTML={{ __html: description }} />
          </Typography>
        )}
        <DSButton special={special ? 'true' : 'false'} onClick={onClick}>
          {buttonText}
        </DSButton>
      </div>
      <div>
        <img src={imgSrc} alt={imgAlt} />
      </div>
    </div>
  );
};

export const CustomWideCard: React.FC<CustomWideCardProps> = ({ children, customStyles }) => (
  <div className={`${customStyles || ''} ds-card-wide`}>{children}</div>
);
